'use client';

import { c as _c } from "react/compiler-runtime";
import { StaticImageData } from 'next/image';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import LazyImage from './lazy-image';
import { RelatedFileType } from '@/types/file';
import { getResizedPictureUrl } from '@/lib/utils';
type PropsType = {
  pictures: StaticImageData[] | RelatedFileType[];
  title?: string;
};
const ContentPictures = t0 => {
  const $ = _c(9);
  const {
    pictures,
    title: t1
  } = t0;
  const title = t1 === undefined ? "" : t1;
  if (!pictures || pictures.length === 0) {
    return null;
  }
  const isStaticImages = pictures.length > 0 && "src" in pictures[0];
  let t2;
  if ($[0] !== isStaticImages || $[1] !== pictures || $[2] !== title) {
    let t3;
    if ($[4] !== isStaticImages || $[5] !== title) {
      t3 = (picture, index) => {
        if (isStaticImages) {
          const staticPicture = picture as StaticImageData;
          return <PhotoView key={index} src={staticPicture.src}><div className="group relative aspect-video cursor-pointer overflow-hidden rounded-lg"><LazyImage src={staticPicture.src} alt={`${title} - ${index + 1}`} fill={true} sizes="(max-width: 768px) 50vw, 33vw" className="object-cover transition-transform duration-300 group-hover:scale-110" /><div className="absolute inset-0 bg-black/0 transition-all group-hover:bg-black/20" /></div></PhotoView>;
        } else {
          const dynamicPicture = picture as RelatedFileType;
          const imageUrl = getResizedPictureUrl(dynamicPicture.file.path, 800, 600);
          const fullImageUrl = getResizedPictureUrl(dynamicPicture.file.path, 1920, 1080);
          return <PhotoView key={index} src={fullImageUrl}><div className="group relative aspect-video cursor-pointer overflow-hidden rounded-lg"><LazyImage src={imageUrl} alt={`${title} - ${index + 1}`} fill={true} sizes="(max-width: 768px) 50vw, 33vw" className="object-cover transition-transform duration-300 group-hover:scale-110" /><div className="absolute inset-0 bg-black/0 transition-all group-hover:bg-black/20" /></div></PhotoView>;
        }
      };
      $[4] = isStaticImages;
      $[5] = title;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = pictures.map(t3);
    $[0] = isStaticImages;
    $[1] = pictures;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <PhotoProvider><div className="grid grid-cols-2 gap-4 md:grid-cols-3">{t2}</div></PhotoProvider>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default ContentPictures;